import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate, FormattedMessage} from "react-intl";

EndDate.propTypes = {
    date: PropTypes.string
};

function EndDate({date}) {
    if (!date) {
        return <FormattedMessage id='feed.history.not_finish' />
    }

    return (
        <FormattedDate
            value={new Date(date)}
            year={"numeric"}
            month={"numeric"}
            day={"numeric"}
            hour={"numeric"}
            minute={"numeric"}
            second={"numeric"}
        />
    );
}

export default EndDate;
